import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  GetDockAll (URL, header, success, error) {
    Vue.axios.get(URL + 'report/getdock', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  GetPartAll (URL, header, success, error) {
    Vue.axios.get(URL + 'report/getpart', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  GetPartByDockID (URL, header, success, error) {
    Vue.axios.get(URL + 'report/getpartbydockid', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  GetShelfAll (URL, header, success, error) {
    Vue.axios.get(URL + 'report/getshelf', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportPartLinkage (URL, header, success, error) {
    Vue.axios.get(URL + 'report/partlinkage', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportInspect (URL, header, success, error) {
    Vue.axios.get(URL + 'report/inspect', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportReceive (URL, header, success, error) {
    Vue.axios.get(URL + 'report/receive', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportReceiveOrder (URL, header, success, error) {
    Vue.axios.get(URL + 'report/receiveorder', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportIssue (URL, header, success, error) {
    Vue.axios.get(URL + 'report/issue', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportStockTracking (URL, header, success, error) {
    Vue.axios.get(URL + 'report/stockpartlinkage', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportStockShelfTracking (URL, header, success, error) {
    Vue.axios.get(URL + 'report/stockshelf', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportStockHistory (URL, header, success, error) {
    Vue.axios.get(URL + 'report/stockhistory', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportAdjust (URL, header, success, error) {
    Vue.axios.get(URL + 'report/adjust', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportMaxmin (URL, header, success, error) {
    Vue.axios.get(URL + 'report/maxmin', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  Reportallpartserial (URL, header, success, error) {
    Vue.axios.get(URL + 'report/allpartserial', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDockList (URL, header, success, error) {
    Vue.axios.get(URL + 'report/docklist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSupplierList (URL, header, success, error) {
    Vue.axios.get(URL + 'report/supplierlist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPartList (URL, header, success, error) {
    Vue.axios.get(URL + 'report/getpartlist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDockBySpl (URL, header, success, error) {
    Vue.axios.get(URL + 'report/dockbyspl', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSupplierByDk (URL, header, success, error) {
    Vue.axios.get(URL + 'report/supplierbydk', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  PartList (URL, header, success, error) {
    Vue.axios.get(URL + 'report/partlist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/reports.js